import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { ItemOrcamento } from 'src/app/admihair/api/dto/item-orcamento';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { ResgatePacoteRequest } from 'src/app/admihair/api/dto/resgate-pacote-request';

@Component({
  selector: 'app-central-cliente-pacote-detalhar',
  templateUrl: './central-cliente-pacote-detalhar.component.html',
  styleUrls: ['./central-cliente-pacote-detalhar.component.scss']
})
export class CentralClientePacoteDetalharComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  orcamento?: Orcamento;
  itensOrcamento: ItemOrcamento[] = [];
  loading: boolean = true;

  exibirDialogResgate: boolean = false;
  loadingPacote: boolean = false;
  listaTiposPagamento: TipoPagamento[] = [];
  tipoPagamentoSelecionado?: TipoPagamento;
  dataPagamentoSelecionada: Date = new Date();

  tipoResgate: string = '';
  loadingResgate: boolean = false;


  constructor(private tipoPagamentoService: TipoPagamentoService,
    private orcamentoService: OrcamentoService,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService);
  }

  ngOnInit(): void {
    this.carregarIdOrcamento();
    this.carregarOrcamento();
  }

  carregarIdOrcamento() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarOrcamento() {
    this.orcamentoService.buscarPorId(this.id).subscribe({
      next: (data: Orcamento) => {
        this.orcamento = data;
        this.itensOrcamento = data.listaItens ?? [];
        //this.calcularValorAResgatar();
        this.setExibirSpinnerPrincipal(false);
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirDialogResgatePacote() {
    this.loadingPacote = true;
    this.tipoPagamentoSelecionado = undefined;
    this.dataPagamentoSelecionada = new Date();
    this.exibirDialogResgate = true;
    this.carregarTiposPagamento();
  }

  carregarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresaEOperacaoDespesa(this.getEmpresa().id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.listaTiposPagamento = data;
          this.loadingPacote = false;
        },
        error: (err: any) => {
          this.loadingPacote = false;
          this.exibirDialogResgate = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  resgatarPacote() {
    this.loadingResgate = true;
    const resgate: ResgatePacoteRequest = {
      pacoteId: this.orcamento?.id,
      tipoResgate: this.tipoResgate,
      clienteId: this.orcamento?.interessado?.id,
      tipoPagamentoId: this.tipoPagamentoSelecionado?.id,
      dataPagamento: this.dataPagamentoSelecionada
    }
    this.orcamentoService.resgatarPacote(resgate).subscribe({
      next: () => {
        this.exibirMensagemSucesso();
        this.carregarOrcamento();
        this.loadingResgate = false;
        this.exibirDialogResgate = false;
      },
      error: (err: any) => {
        this.loadingResgate = false;
        this.exibirDialogResgate = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  calcularValorAResgatar(item: ItemOrcamento) {
    const descontoGeral = this.orcamento?.desconto ?? 0;

    const saldoQuantidade = (item.quantidadeProposta ?? 0) - (item.quantidadeEntregue ?? 0);
    const totalSemDesconto = (item.valorUnitario ?? 0) * saldoQuantidade;

    const valorTotalItem = totalSemDesconto - (totalSemDesconto * (item.descontoItem ?? 0) / 100);
    const valorAResgatarItem = valorTotalItem - (valorTotalItem * descontoGeral / 100);

    return valorAResgatarItem;

  }

}
